import { createAction, props } from '@ngrx/store';

import {
  InstitutionProgram,
  ProgramsForInstitutionOptions
} from '@cpd-app/core-module/models';

export const loadInstitutionPrograms = createAction(
  '[InstitutionProgram] Load Institution Programs'
);

export const loadInstitutionProgramsSuccess = createAction(
  '[InstitutionProgram] Load Institution Programs Success',
  props<{ institutionPrograms: InstitutionProgram[] }>()
);

export const loadInstitutionProgramsFailure = createAction(
  '[InstitutionProgram] Load Institution Programs Failure',
  props<{ error: any }>()
);

export const updateProgramsForInstitutionOptions = createAction(
  '[InstitutionProgram] Update Programs For Institution Options',
  props<{ options: Partial<ProgramsForInstitutionOptions> }>()
);

export const clearProgramsForInstitutionOptions = createAction(
  '[InstitutionProgram] Clear Update Programs For Institution Options'
);
